import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { IQuestionSubType } from "../../../Pages/QuestionSubType/IQuestionSubType";

export const DeleteQuestionSubTypeSlice = createSlice({
  name: "DeleteQuestionSubType",
  initialState: {} as IReduxState<IQuestionSubType>,
  reducers: {
    deleteQuestionSubType: (state, _) => {
      state.isLoading = true;
    },
    successdeleteQuestionSubType: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failuredeleteQuestionSubType: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearDeleteQuestionSubTypeResponse: (state) => {
      state.data = {};
    },
  },
});

export const {
  deleteQuestionSubType,
  failuredeleteQuestionSubType,
  successdeleteQuestionSubType,
  clearDeleteQuestionSubTypeResponse,
} = DeleteQuestionSubTypeSlice.actions;

export default DeleteQuestionSubTypeSlice.reducer;
